import store from "../store";
import router from "@/router";

export default function (item, key) {
    let startParams = {};
    if(router.currentRoute.name === 'DealersCars'){
        startParams = store.state.newCars.startParams;
    }

    if(router.currentRoute.name === 'OldCars'){
        startParams = store.state.moduleOldCars.startParams;
    }

    if(typeof(startParams[key]) === 'object'){
        const min = item[0] ? item[0] : startParams[key].min;
        const max = item[1] ? item[1] : startParams[key].max;
        if(!startParams[key].filterString){
            return false;
        }
        let name = startParams[key].filterString;

        //console.log(">>>>>>>>>>>>>>>>>>>>>"+key,[min,max])

        name = name.replace('[min]', key === "argerd" ? min : parseInt(min).format());
        name = name.replace('[max]', key === "argerd" ? max : parseInt(max).format());
        //console.log("name",name)
        return name;
    }else{
        return  false;
    }

}
